import * as actionType from '../actions/actionTypes';
const initialState = {
  transactionHistory: [],
  transactionDetails: {},
  errors: ''
}

export default function (state = initialState, action) {
  switch (action.type) {
    case actionType.GET_DOOSRA_CASH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactionHistory: action.payload,
        errors: ''
      }
    case actionType.GET_DOOSRA_CASH_TRANSACTIONS_FAIL:
      return {
        ...state,
        errors: 'no user found',
        transactionHistory: []
      }
    case actionType.CLEAR_DOOSRA_CASH_TRANSACTIONS_LIST:
      return {
        ...state,
        errors: '',
        transactionHistory: []
      }
    case actionType.GET_TRANSACTION_DETAILS:
      return {
        ...state,
        transactionDetails: action.payload
      }
    case actionType.CLEAR_TRANSACTION_DETAILS:
      return {
        ...state,
        transactionDetails: {}
      }
    default:
      return state;
  }
}

